// 创建文件en/index.js
const Thai = {
    my: "ของฉัน",
    today: "วันนี้",
    this_week: "สัปดาห์นี้",
    this_month: "เดือนนี้",
    last_month: "เดือนที่แล้ว",
    this_year: "ปีนี้",
    number_of_people: "จำนวนคน",
    amount: "จำนวนเงิน",
    enter_username_id_to_search: "กรอกชื่อผู้ใช้ ID เพื่อค้นหา",
    team_list: "รายการทีม",
    registration_time: "เวลาลงทะเบียน",
    selling_face_value: "มูลค่าหน้าขาย",
    click_for_details: "คลิกเพื่อดูรายละเอียด",
    "agent_login": "เข้าสู่ระบบตัวแทน",
    "Agent.Center": "ศูนย์ตัวแทน",
    'SignOut': 'ออกจากระบบ',
    'Contact us': "ติดต่อเรา",
    'Download our app': "ดาวน์โหลดแอปของเรา",
    'Download it from': "ดาวน์โหลด URL",
    'About Us': "เกี่ยวกับเรา",
    'Gobuy USA was founded in 2012': "Gobuy USA ก่อตั้งขึ้นในปี 2012",
    'Customer service': "การบริการลูกค้า",
    'frequently asked question': "คำถามที่พบบ่อย",
    'Return and exchange policy': "นโยบายการคืนและเปลี่ยนสินค้า",
    'Shipping and distribution': "การจัดจำหน่ายและการส่งมอบ",
    'Contact us by email': "ติดต่อเราผ่านทางอีเมล",
    'Privacy Policy and Terms of Use': "นโยบายความเป็นส่วนตัวและข้อกำหนดการใช้งาน",
    'Privacy Policy': "นโยบายความเป็นส่วนตัว",
    'Terms of use': "เงื่อนไขการใช้งาน",
    'Upload credentials': "อัปโหลดข้อมูลรับรอง",
    'The withdrawal is being processed': "อยู่ระหว่างการถอนเงิน",
    'Cause of failure': "สาเหตุของความล้มเหลว",
    'Your shopping cart is still empty': "ตะกร้าสินค้าของคุณยังว่างเปล่า",
    'Log in to view the items in your cart': "เข้าสู่ระบบเพื่อดูสินค้าในตะกร้าสินค้า",
    'Browse around': "เรียกดู",
    'Account correlation': "บัญชีที่เกี่ยวข้อง",
    'Order management': "การจัดการคำสั่งซื้อ",
    'Payment method': "วิธีการชำระเงิน",
    'Collection address': "ที่อยู่การชำระเงิน",
    Category: "การจำแนกประเภท",
    "MyCommission": "ค่าคอมมิชชั่นของฉัน",
    "Gross income": "รายได้ทั้งหมด",
    "Direct commission": "ค่าคอมมิชชั่นโดยตรง",
    "Indirect commission": "ค่าคอมมิชชั่นทางอ้อม",
    "Transfer to wallet": "โอนเข้ากระเป๋าสตางค์",
    "Tip: The transfer amount must be greater than 10USDT": "เคล็ดลับ: จำนวนเงินโอนจะต้องมากกว่า 10USDT",
    "transfer": "โอนย้าย",
    "commission": "คณะกรรมการ",
    "Please enter": "กรุณาเข้า",
    "Team Commission": "ค่าคอมมิชชั่นทีม",

    'Old Password': "รหัสผ่านเก่า",
    'Change password': "เปลี่ยนรหัสผ่าน",
    'Gobuy GIFT CARD': "บัตรของขวัญ Gobuy",
    'High Priced Recycling': "การรีไซเคิลราคาสูง",
    'Data': "วันที่",
    'congratulations': "ยินดีด้วย",
    'Obtain': "รับ",
    'ThankYouForParticipating': "ขอบคุณสำหรับการเข้าร่วม",

    // navbar"",
    Home: "หน้าแรก",
    Search: "ค้นหา",
    ShoppingCart: "ตะกร้าสินค้า",
    Mine: "ของฉัน",

    // 首页
    // 搜索
    EnterSearchContent: "ป้อนเนื้อหาการค้นหา",
    'Recent searches': "การค้นหาล่าสุด",
    'popular searches': "การค้นหายอดนิยม",
    'Please search': "กรุณากรอกคำสำคัญที่คุณต้องการค้นหา",
    'orderSearch': "กรอกชื่อคำสั่งซื้อหรือสินค้าเพื่อค้นหา",

    // 语言
    'Language selection': "การเลือกภาษา",

    // menu
    Brand: "ยี่ห้อ",
    Collect: "เก็บรวบรวม",
    Manage: "จัดการ",
    Order: "คำสั่ง",
    Wallet: "กระเป๋าสตางค์",
    BlindBox: "กล่องตาบอด",
    MenuGiftCard: "บัตรของขวัญ",
    // HotSale
    HotSale: "ข่าวล่าสุด กำลังลดราคา...",
    // tabs"",
    TodaysOffer: "แพลตฟอร์มที่แนะนำ",
    'Phone': "โทรศัพท์มือถือ",
    'Smart Watch': "นาฬิกาอัจฉริยะ",
    'Smart bracelet': "สร้อยข้อมืออัจฉริยะ",

    // gobuy
    'home.gobuy.title': "ความประหลาดใจกำลังรอคุณอยู่",
    'home.gobuy.periods': "กล่องตาบอดทรงกลม",
    'home.gobuy.freeze': "มีส่วนร่วมในการนับถอยหลัง",
    'home.gobuy.drawing': "เริ่มนับถอยหลัง",
    'home.gobuy.buy': "เข้าร่วม",
    'home.gobuy.isbuy': "เข้าร่วมแล้ว",
    USDT: "ดอลลาร์สหรัฐฯ",
    'home.gobuy.jackpot': "เงินรางวัลรวม",
    Purse: "กระเป๋าสตางค์",
    Box: "กล่องตาบอด",
    'GetAPrize': "รับรางวัล",
    Discount: "การลดราคา",
    when: "เมื่อไร",
    points: "บูรณาการ",
    seconds: "ที่สอง",
    // MessageBox
    'MessageBox.Tips': "คำใบ้",
    'MessageBox.Confirm': "ยืนยัน",
    'MessageBox.Cancel': "ยกเลิก",
    'MessageBox.buy.box': "คุณแน่ใจหรือไม่ว่าต้องการซื้อกล่องตาบอดนี้",
    // Toast
    'succ': "ความสำเร็จ",
    'err': "ความผิดพลาด",
    'box.succeeds': "การซื้อสำเร็จ",
    'box.frozen': "เข้าร่วมแล้ว",
    'box.issue': "สามารถซื้อกล่องตาบอดได้เพียงกล่องเดียวต่อฉบับ",

    // 商品列表
    filter: "กรอง",
    sales: "ปริมาณการขาย",
    selfOP: "ดำเนินการด้วยตนเอง",
    noMore: "ไม่มีอีกแล้ว",
    brand: "ยี่ห้อ",
    confirm: "ยืนยัน",
    reset: "รีเซ็ต",
    ComSor: "การเรียงลำดับที่ครอบคลุม",
    MostPop: "ที่นิยมมากที่สุด",
    HighLow: "ราคาจากสูงไปต่ำ",
    LowHigh: "ราคาจากต่ำไปสูง",
    SalVol: "ปริมาณการขาย",
    NewArr: "มาใหม่",

    // 购物车
    'cart.cart': "ตะกร้าสินค้า",
    'cart.edit': "แก้ไข",
    'cart.done': "เสร็จ",
    'home.cart.voucher': "รับคูปอง",
    'home.cart.outstock': "สินค้าหมด",
    'home.cart.offshelf': "ถอดออกจากชั้นวางแล้ว",
    'Only': "เท่านั้น",
    'left': "รายบุคคล",
    'Promotion': "การส่งเสริม",
    'cart.all': "เลือกทั้งหมด",
    'cart.total': "ทั้งหมด",
    'cart.delete': "ลบ",
    'cart.checkout': "บิล ได้โปรด",

    // 我的
    'Direct': "โดยตรง",
    'Indirect': "ทางอ้อม",
    'MyOrders': "คำสั่งซื้อของฉัน",
    'ViewAll': "ดูทั้งหมด",
    'Unpaid': "รอการชำระเงิน",
    'ToShip': "รอจัดส่ง",
    'ToReceive': "รอรับ",
    'ToReview': "รอการประเมิน",
    // 盲盒
    'MyBlindBox': "รายการกล่องตาบอด",
    'WaitingDraw': "รอหวยครับ",
    'Opened': "เปิดแล้ว (รับ/คืน)",
    // 礼品卡
    'After sale': "หลังการขาย",
    'GiftCard': "บันทึกการรีไซเคิล",
    'RecycleGiftCard': "รีไซเคิลบัตรของขวัญ",
    'Verifying': "ตรวจสอบ",
    'Rebuying': "การซื้อคืน",
    'Repurchased': "รอการชำระเงิน",
    'Paid': "ชำระเงินเรียบร้อยแล้ว",
    // 常用工具
    'CommonTools': "เครื่องมือทั่วไป",
    'MyWallet': "กระเป๋าเงินของฉัน",
    'VirtualOrders': "คำสั่งซื้อเสมือน",
    'Refunds': "คืนเงิน",
    'MyFriends': "เพื่อนของฉัน",
    'ChatList': "รายการสนทนา",
    'RealNameVerification': "การตรวจสอบชื่อจริง",
    'MyFavorites': "คอลเลกชันของฉัน",
    'Addresses': "การจัดการที่อยู่",
    'MyReviews': "รีวิวของฉัน",
    'BrowsingHistory': "เรียกดูประวัติ",
    'Promotions': "โปรโมชั่น",
    'StoreManagement': "การจัดการร้านค้า",
    'BecomeASeller': "มาเป็นผู้ขาย",

    // 订单列表
    'SearchPlaceholder': "กรอกชื่อสินค้าที่ต้องการค้นหา",
    All: "ทั้งหมด",
    OrderNo: "หมายเลขคำสั่งซื้อ",
    items: "ชิ้นส่วน",
    ShippingFee: "ค่าขนส่ง",
    'Refund in Progress': "อยู่ระหว่างดำเนินการคืนเงิน",
    'Cancel Order': "ยกเลิกคำสั่งซื้อ",
    'Refund': "คืนเงิน",
    'Track Shipping': "ตรวจสอบโลจิสติกส์",
    'Confirm Receipt': "ยืนยันการรับสินค้า",
    'Evaluate': "ประเมิน",
    'Delete': "ลบ",
    'Pay': "การชำระเงิน",
    'MessageBox.delete.order': "คุณแน่ใจหรือไม่ว่าต้องการลบคำสั่งซื้อนี้",
    'MessageBox.cancel.order': "คุณแน่ใจหรือไม่ว่าต้องการยกเลิกคำสั่งซื้อนี้",
    'MessageBox.receive.order': "คำสั่งซื้อนี้ได้รับแล้วหรือยัง?",
    // 订单详情
    'Order Details': "รายละเอียดการสั่งซื้อ",
    'Pickup Code': "รหัสการรับสินค้า",
    'Complaint': "ร้องเรียน",
    'After-Sales': "หลังการขาย",
    'Gift': "ของขวัญ",
    'Order Date': "วันที่สั่งซื้อ",
    'Used voucher worth': "จำนวนบัตรกำนัลที่ใช้",
    'CNY': "หยวน",
    'Payment Method': "วิธีการชำระเงิน",
    'Total Product Amount': "จำนวนผลิตภัณฑ์ทั้งหมด",
    'Shipping Fee': "ค่าขนส่ง",
    'Amount Paid': "จำนวนเงินที่ชำระ",
    'Return': "คืนสินค้า",
    // 盲盒列表
    'Pending Draw': "รอการจับสลาก",
    'Pending Unboxing': "ที่จะถูกเปิด",
    'Unboxed': "เปิดอยู่แล้ว",
    'Collected': "ได้รับ",
    'Recycled': "รีไซเคิล",
    'Unknown': "ไม่ทราบ",
    'Claim': "รับ",
    'Recycle': "การซื้อคืน",
    'Unbox': "เปิดเครื่อง",
    'MessageBox.recycle.box': "คุณแน่ใจหรือไม่ว่าต้องการรีไซเคิลกล่องตาบอดนี้",
    // 盲盒详情
    'Mystery Box Details': "รายละเอียดกล่องตาบอด",
    'Unopened': "ไม่ได้เปิด",
    'box.opened': "ไม่ได้เปิด",
    'Claimed': "ได้รับ",
    'Confirm Claim': "ยืนยันการรวบรวม",
    'MessageBox.pick.box': "คุณแน่ใจหรือไม่ว่าต้องการแยกกล่องตาบอดนี้",
    // 盲盒提货
    'Please add address': "กรุณาเพิ่มที่อยู่",
    // 礼品卡列表
    'Face Value Total': "มูลค่าหน้าบัตรทั้งหมด",
    // 礼品卡详情
    'Gift Card Details': "รายละเอียดบัตรของขวัญ",
    'Card number': "หมายเลขบัตร",
    'Activation code': "รหัสเปิดใช้งาน",
    'Actual recovery price': "ราคารีไซเคิลตามจริง",
    // 礼品卡回收
    'Gift Card Recycling': "การรีไซเคิลบัตรของขวัญ",
    'Confirm Recycling': "ยืนยันการรีไซเคิล",
    'Please enter the card number': "กรุณากรอกหมายเลขบัตร",
    'Please enter the activation code': "กรุณากรอกรหัสเปิดใช้งาน",
    'MessageBox.recycle.gift': "คุณแน่ใจหรือไม่ว่าต้องการรีไซเคิลบัตรของขวัญนี้",

    // 我的钱包
    'My Wallet': "กระเป๋าเงินของฉัน",
    'Available Balance': "ยอดคงเหลือที่มีอยู่",
    'Frozen Funds': "แช่แข็งเงินทุน",
    'Recharge': "เติมเงิน",
    "can": "สามารถ",
    'Withdraw': "ถอนเงินสด",
    'Withdrawal Accounts': "ถอนบัญชี",
    // 充值
    'Recharge Details': "รายละเอียดการเติมเงิน",
    'Recharge Order No.': "หมายเลขคำสั่งซื้อเติมเงิน",
    'Recharge Amount': "จำนวนการเติมเงิน",
    'Creation Time': "เวลาสร้าง",
    'MessageBox.recharge.pop': "กรุณากรอกจำนวนเงินที่เติม",
    // 付款
    'payment': "การชำระเงิน",
    'Order submitted successfully, please select payment method': "ส่งคำสั่งซื้อเรียบร้อยแล้ว กรุณาเลือกวิธีการชำระเงิน",
    'Rechargeable card': "การ์ดแบบชาร์จไฟได้",
    'Please enter a hash': "กรุณาใส่แฮช",
    'Immediate payment': "ชำระเงินตอนนี้",
    'Wait for the file to load': "กรุณารอให้โหลดไฟล์",
    // 提现
    'Withdrawal Details': "รายละเอียดการถอนเงิน",
    'Withdrawal Amount': "ถอนจำนวนเงิน",
    'Application Time': "เวลาสมัคร",
    'New Application': "แอปพลิเคชันใหม่",
    'Payment Password': "รหัสผ่านการชำระเงิน",
    'New Payment Password': "รหัสผ่านการชำระเงินใหม่",
    'Recipient Information': "ข้อมูลผู้รับเงิน",
    'Submit': "ส่ง",
    'Add Recipient Account First': "กรุณาเพิ่มบัญชีการชำระเงินก่อน",
    'Please bind your mobile phone or email first': "กรุณาผูกโทรศัพท์มือถือหรืออีเมลของคุณก่อน",
    // 设置
    'Account Settings': "การตั้งค่าบัญชี",
    'Change Login Password': "เปลี่ยนรหัสผ่านเข้าสู่ระบบ",
    'Change Payment Password': "เปลี่ยนรหัสผ่านการชำระเงิน",
    'Log Out': "ออกจากระบบ",
    'Mobile': "โทรศัพท์มือถือ",
    'Verification Code': "รหัสยืนยัน",
    'Email': "จดหมาย",
    'New Password': "รหัสผ่านใหม่",
    'Confirm Password': "ยืนยันรหัสผ่าน",
    'Modify': "ปรับปรุงใหม่",
    'Bind': "ผูกพัน",
    ' Mobile': "โทรศัพท์มือถือ",
    ' Email': "จดหมาย",
    // 资金详情
    'Fund Details': "รายละเอียดเงินทุน",
    'Withdrawal Account': "ถอนบัญชี",
    'Account Type': "ประเภทบัญชี",
    'USDT Address (opBNB)': "USDT-opBNB",
    'Edit': "แก้ไข",
    'Delete': "ลบ",
    'Add New': "เพิ่มบัญชีใหม่",
    'MessageBox.delete.bank': "คุณแน่ใจหรือไม่ว่าต้องการลบบัญชีถอนเงินนี้",
    // 登录
    'Login': "เข้าสู่ระบบ",
    'Sign Up': "ลงทะเบียน",
    'Normal Login': "เข้าสู่ระบบปกติ",
    'Username / Email / Phone Number': "ชื่อผู้ใช้/อีเมล",
    'Enter Phone Number': "กรุณากรอกหมายเลขโทรศัพท์มือถือ",
    'Enter Email': "กรุณากรอกอีเมล์",
    'Enter SMS Code': "กรุณากรอกรหัสยืนยันทาง SMS",
    'Enter Password': "กรุณากรอกรหัสผ่าน",
    "enter_login_password_for_verification": "กรุณาใส่รหัสผ่านการเข้าสู่ระบบเพื่อยืนยัน",
    'Forgot Password': "ลืมรหัสผ่าน",
    'Third-party Login': "การเข้าสู่ระบบของบุคคลที่สาม",
    'Please complete the form': "กรุณากรอกแบบฟอร์ม",
    'WeChat': "วีแชท",
    'Weibo': "เว่ยป๋อ",
    'QQ': "คิวคิว",
    'phone login': "เข้าสู่ระบบมือถือ",
    'Login Expired': "การเข้าสู่ระบบหมดอายุแล้ว",
    'Please enter your phone number first': "กรุณากรอกหมายเลขโทรศัพท์มือถือของคุณก่อน",
    'Please enter your username/email/phone number': "กรุณากรอกชื่อผู้ใช้/อีเมล",
    'Please enter your password': "กรุณากรอกรหัสผ่าน",
    'Password must be at least 6 characters': "รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร",
    'Please enter an 11-digit phone number': "กรุณากรอกหมายเลขโทรศัพท์มือถือ 11 หลักของคุณ",
    'Please wait for the file to finish loading': "กรุณารอจนกว่าไฟล์จะโหลด",
    'send': "ส่ง",
    'signUpTips': "ข้อมูลส่วนบุคคลของคุณจะถูกนำมาใช้เพื่อสนับสนุนประสบการณ์ของคุณทั่วทั้งเว็บไซต์ จัดการการเข้าถึงบัญชีของคุณ และเพื่อวัตถุประสงค์อื่นที่อธิบายไว้ในนโยบายความเป็นส่วนตัวของเรา",

    // 注册
    'Sign Up': "ลงทะเบียน",
    'Referrer': "ผู้แนะนำ",
    'Invitation code': "รหัสคำเชิญ",
    'Invite friends': "ชวนเพื่อน",
    'Username': "ชื่อผู้ใช้",
    'Full Name': "ชื่อจริง",
    'Set Password': "ตั้งรหัสผ่าน",
    'Confirm Password': "ยืนยันรหัสผ่าน",
    'Phone Number': "หมายเลขโทรศัพท์",
    'Email': "อีเมล",
    'Username: 3-25 chars, letters & numbers': "ชื่อผู้ใช้: 3-25 ตัวอักษร ตัวอักษร และตัวเลข",
    '6-20 digits/letters/symbols': "6-20 หลัก/ตัวอักษร/สัญลักษณ์",
    'By clicking sign up, you agree to': "การคลิกเพื่อลงทะเบียนแสดงว่าคุณยอมรับ",
    'User Agreement': "ข้อตกลงผู้ใช้",
    'Please check the user agreement': "โปรดตรวจสอบข้อตกลงผู้ใช้",
    'Please enter a username with 3-25 characters': "กรุณากรอกชื่อผู้ใช้ที่มีความยาว 3-25 ตัวอักษร",
    'Enter SMS Verification Code': "กรุณากรอกรหัสยืนยันทาง SMS",
    'Please enter your phone number': "กรุณากรอกหมายเลขโทรศัพท์มือถือของคุณ",
    'Please enter the verification code': "กรุณากรอกรหัสยืนยัน",
    'Please enter a 6-digit verification code': "กรุณากรอกรหัสยืนยัน 6 หลัก",
    'Please enter a password with 6-20 characters': "กรุณากรอกรหัสผ่าน 6-20 ตัวอักษร",
    'Please enter the confirm password': "กรุณากรอกรหัสผ่านยืนยัน",
    'The confirm password does not match the entered password': "รหัสผ่านยืนยันไม่ตรงกับรหัสผ่านที่ป้อน",

    // 密码恢复
    'Password Recovery': "การกู้คืนรหัสผ่าน",
    'Forgot Password': "ลืมรหัสผ่าน",
    'Forget.email.tips': "หากบัญชีของคุณยังไม่เชื่อมโยงกับหมายเลขอีเมล โปรดติดต่อผู้ดูแลแพลตฟอร์มเพื่อกู้คืนรหัสผ่านของคุณ",

    // 通知
    'Notification Message': "ข้อความแจ้งเตือน",
    'Direct Message': "ข้อความส่วนตัว",
    'System Message': "ข้อความของระบบ",
    'Leave a Message': "ข้อความ",

    // 配送地址
    'Delivery Address': "ที่อยู่จัดส่ง",
    'The store is no longer valid, please edit the delivery address again': "ร้านค้านี้ใช้ไม่ได้อีกต่อไป โปรดแก้ไขที่อยู่สำหรับจัดส่งอีกครั้ง",
    'Default address': "ที่อยู่เริ่มต้น",
    'Add address': "เพิ่มที่อยู่",
    'Edit address': "แก้ไขที่อยู่",
    'MessageBox.delete.address': "คุณแน่ใจหรือไม่ว่าต้องการลบที่อยู่นี้",
    'name': "ชื่อ",
    'phone': "หมายเลขโทรศัพท์",
    'district': "เขต",
    'address': "ที่อยู่",
    'default address': "ที่อยู่เริ่มต้น",
    'save and use': "บันทึกและใช้งาน",
    'save': "บันทึก",
    'Please select a region': "โปรดเลือกภูมิภาค",
    'Please fill in the recipient name': "กรุณากรอกชื่อผู้รับ",
    'Name must be 2-15 characters': "ชื่อต้องมีอักขระ 2-15 ตัว",
    'Please fill in the mobile phone number': "กรุณากรอกหมายเลขโทรศัพท์มือถือ",
    'Please select your location': "กรุณาเลือกสถานที่ของคุณ",
    'Please fill in the detailed address': "กรุณากรอกที่อยู่โดยละเอียด",

    // 浏览历史
    'Browsing History': "เรียกดูประวัติ",
    'Clear browsing history': "ล้างประวัติการเข้าชม",

    // 推广会员
    'Promotion member': "ส่งเสริมสมาชิก",
    "PromotionPoster": "โปสเตอร์ส่งเสริมการขาย",
    "MemberName": "ชื่อสมาชิก",
    "MyAssets": "ทรัพย์สินของฉัน",
    "DistributedAmount": "จำนวนการจำหน่าย",
    "NumberOfDistributedProducts": "กำหนดปริมาณผลิตภัณฑ์",
    "DistributedProductAmount": "จำนวนการจำหน่าย",
    "MyTeam": "ทีมของฉัน",
    "LevelOneMembers": "สมาชิกชั้นหนึ่ง",
    "LevelTwoMembers": "สมาชิกระดับที่สอง",
    "PromotionPoster": "โปสเตอร์ส่งเสริมการขาย",
    "PromotionMembers": "ส่งเสริมสมาชิก",
    "PromotionPerformance": "ประสิทธิภาพการส่งเสริมการขาย",
    "ViewPromotionLink": "คลิกดูลิงค์โปรโมชั่น",
    "PromoteViaWeChatQRCode": "โปรโมตผ่านรหัส QR WeChat",
    "Copy": "สำเนา",
    "BrowserNotSupportedCopyManually": "เบราว์เซอร์ของคุณไม่รองรับการคัดลอกโดยตรง โปรดคัดลอกด้วยตนเอง",
    "GiftCardRecoveryTotal": "จำนวนบัตรของขวัญที่รีไซเคิลทั้งหมด",
    "TodaysGiftCardRecoveryCount": "จำนวนการรีไซเคิลบัตรของขวัญในวันนี้",
    "RegistrationDate": "วันที่ลงทะเบียน",
    "LastLogin": "เข้าสู่ระบบครั้งล่าสุด",
    "Promotion Commission": "ค่าคอมมิชชั่นส่งเสริมการขาย",

    // userinfo 个人信息
    "Personal Info": "ข้อมูลส่วนบุคคล",
    "Nickname": "ชื่อนิค",
    "Birthdate": "วันเดือนปีเกิด",
    "Save": "บันทึก",
    "CropImage": "ครอบตัดรูปภาพ",
    "UseImage": "ใช้รูปภาพ",

    // goodsDetail 商品详情
    "Off": "การลดราคา",
    "Sold": "ขายแล้ว",
    "Product": "ผลิตภัณฑ์",
    "Comment": "ความคิดเห็น",
    "Details": "รายละเอียด",
    "ReportViolation": "รายงาน",
    "Cart": "ตะกร้าสินค้า",
    "ChatMessages": "ข้อความแชท",
    "MyShop": "ร้านค้าของฉัน",
    "MerchantLogin": "เข้าสู่ระบบผู้ค้า",
    "Share": "แบ่งปัน",
    "ShareTo": "แบ่งปันไปที่",
    "WeChat": "วีแชท",
    "Copy": "สำเนา",
    "Poster": "โปสเตอร์",
    "BrowserNotSupportedCopyManually": "เบราว์เซอร์ของคุณไม่รองรับการคัดลอกโดยตรง โปรดคัดลอกด้วยตนเอง",
    "Follow": "มุ่งเน้นไปที่",
    "Unfollow": "เลิกติดตาม",
    "PleaseSelectQuantityAndCategory": "กรุณาเลือกจำนวนและประเภท",
    "SelectedWithQuantity1": "เลือกแล้ว {ข้อกำหนด} ปริมาณ {จำนวน}",
    "SelectedQuantity1": "ปริมาณที่เลือก {number}",
    "SelectedWithQuantity2": "เลือกแล้ว {ข้อกำหนด} ปริมาณ {จำนวน}",
    "Add to cart": "เพิ่มลงในรถเข็น",
    "Buy now": "ซื้อเลย",
    "Stock": "ในสต็อก",
    "Pieces": "ชิ้นส่วน",
    "Quantity": "ปริมาณ",
    "All": "ทั้งหมด",
    "Good": "ความคิดเห็นที่ดี",
    "Medium": "คะแนนเป็นกลาง",
    "Bad": "รีวิวไม่ดี",
    // 评论
    "Product review": "รีวิวสินค้า",
    "anonymous": "ไม่ระบุชื่อ",
    "noReviewInfo": "ไม่มีข้อมูลความคิดเห็นให้",
    "Shop Owners Response": "แม่ค้าตอบกลับ",
    "This product has no current reviews": "ขณะนี้ไม่มีความคิดเห็นสำหรับผลิตภัณฑ์นี้",
    "Product details": "รายละเอียดสินค้า",
    "shop": "ร้านค้า",
    "customerService": "การบริการลูกค้า",
    "shoppingCart": "ตะกร้าสินค้า",
    "addToCart": "เพิ่มลงในรถเข็น",
    "buyNow": "ซื้อเลย",
    "outOfStock": "สินค้าที่เลือกอยู่ในขณะนี้หมดสต๊อก ขออภัย!",
    "notAvailable": "สินค้าที่เลือกไม่มีจำหน่ายแล้ว ขออภัย!",
    "Store order message": "ข่าวสารการสั่งซื้อของทางร้าน",
    "Confirm the order": "ยืนยันการสั่งซื้อ",
    "productAmount": "จำนวนสินค้า",
    "discount": "การลดราคา",
    "shippingFee": "ค่าขนส่ง",
    "subtotal": "เก็บผลรวมย่อย",
    "Submit an order": "ส่งคำสั่งซื้อ",
    // 退货
    "refundAdd": "เพิ่มการคืนเงิน",
    "back": "กลับ",
    "refundDescription": "คำแนะนำการคืนเงิน:",
    "proofOfRefund": "บัตรกำนัลการคืนเงิน",
    "use": "ใช้",

    // 一元购
    "yi1": `การซื้อ 1 บาท`,
    "yi2": `โซนราคา`,
    "yi3": `โซน`,
    "yi4": `ประวัติการซื้อ`,
    "yi5": `บันทึกสินค้าที่ได้รับ`,
    "yi6": `ดูรหัสแลกเปลี่ยน`,
    "yi7": `ขอถอนเงิน`,
    "yi8": `เติมเงิน`,
    "yi9": `จำนวนที่เข้าร่วม`,
    "yi10": `จำนวนทั้งหมด`,
    "yi11": `จำนวนที่ขาด`,
    "yi12": `ซื้อทันที`,
    "yi13": `ซื้อเพิ่มเติม`,
    "yi14": `โซนอื่น ๆ`,
    "yi15": `โหลดเพิ่มเติม`,
    "yi16": `เร็ว ๆ นี้...`,
    "yi17": `โซน`,
    "yi18": `รอบที่`,
    "yi19": `รอบ`,
    "yi20": `ราคา: `,
    "yi21": `โหลดเพิ่มเติม`,
    "yi22": `การชำระเงินด่วน - ข้อมูลสินค้าที่คุณต้องการซื้อ`,
    "yi23": `จำนวนที่จะซื้อ`,
    "yi24": `(ยิ่งซื้อเยอะ โอกาสได้รับสินค้ายิ่งสูง!)`,
    "yi25": `รวมทั้งหมด: `,
    "yi26": `ชำระเงินสำเร็จ`,
    "yi27": `การชำระเงินล้มเหลว`,
    "yi28": `เหตุผล: `,
    "yi29": `ประกาศผล`,
    "yi30": `รหัสซื้อโชคดี`,
    "yi31": `ผู้ชนะสินค้า`,
    "yi32": `ยินดีด้วย! คุณได้รับสินค้าชิ้นนี้`,
    "yi33": `เวลาประกาศ: `,
    "yi34": `เวลาซื้อ: `,
    "yi35": `จำนวนสินค้าที่ผู้ชนะซื้อทั้งหมด: `,
    "yi36": ` รหัสซื้อ:`,
    "yi37": `รับสินค้า`,
    "yi38": `เงินสดเข้า`,
    "yi39": `พรีออเดอร์`,
    "yi40": `ซื้อ`,
    "yi41": `บันทึกสินค้าที่ได้รับ`,
    "yi42": `วันที่ได้รับรางวัล: `,

    "hunt1": `รหัสแลก`,
    "hunt2": `โชคดีมหาศาล`,
    "hunt3": `ไม่มีใครหยุดได้`,
    "hunt4": `รหัสแลกเปลี่ยน`,
    "hunt5": `รหัสแลกเปลี่ยน: `,
    "hunt6": `โหลดเพิ่มเติม`,
    "hunt7": `ฉันต้องการแลก`,
    "hunt8": `กรุณาใส่รหัสแลกเปลี่ยน`,
    "hunt9": `ราคาสำหรับแลกเปลี่ยนคือส่วนลด 10% จากราคาขาย`,
    "hunt10": `รายการสินค้า`,
    "hunt11": `โซน`,
    "hunt12": `ภาษา`,
    "hunt13": `ประกาศ`,
    "hunt14": `การนำทาง`,
    "hunt15": `ประกาศอย่างเป็นทางการ`,
    "hunt16": `บันทึกขุมทรัพย์`,
    "hunt17": `กฎการจัดส่งสินค้า`,
    "hunt18": `คำอธิบายกฎ`,
    "hunt19": `ฉันต้องการแลก`,
    "hunt20": `ติดต่อเรา`,
    "hunt21": `อีเมล`,
    "hunt22": `กฎการจับรางวัล`,
    "hunt23": `ภาพรวมของกฎ`,
    "hunt24": `1. การจัดสรรหมายเลข: `,
    "hunt25": `ทุกครั้งที่จ่าย 0.1 USDT ผู้ใช้จะได้รับหมายเลขโชคดีหนึ่งหมายเลข เริ่มต้นที่ 000001 และจัดสรรตามลำดับจนกว่าจะถึงจำนวนผู้เข้าร่วมเป้าหมาย (เช่น 1,000 คน)`,
    "hunt26": `2. เงื่อนไขการจับรางวัล: `,
    "hunt27": `เมื่อสินค้าถึงจำนวนผู้เข้าร่วมเป้าหมาย (เช่น 1,000) กระบวนการจับรางวัลจะเริ่มขึ้น`,
    "hunt28": `3. เวลาการจับรางวัล: `,
    "hunt29": `หลังจากยืนยันคำสั่งซื้อสุดท้ายแล้ว รอเวลาบล็อกเชนที่ใกล้ที่สุดซึ่งลงท้ายด้วย 05, 10, 15, 25, 30, 35, 40, 45, 50, 55 หรือเต็มชั่วโมง`,
    "hunt30": `4. การคำนวณหมายเลขที่ชนะ: `,
    "hunt31": `1. ดึงตัวเลขล้วนจากแฮชของบล็อก และคำนวณโมดูลัสกับจำนวนผู้เข้าร่วมทั้งหมด:
                หมายเลขที่ชนะ = (ตัวเลขล้วนจากแฮช % จำนวนผู้เข้าร่วม) + 1`,
    "hunt32": `2. ผลลัพธ์ที่คำนวณได้คือหมายเลขที่ชนะ`,
    "hunt33": `ขั้นตอนการเข้าร่วม`,
    "hunt34": `ผู้ใช้จะได้รับหมายเลขโชคดีหนึ่งหมายเลขทุกครั้งที่จ่าย 0.1 USDT`,
    "hunt35": `เมื่อสินค้าถึงจำนวนผู้เข้าร่วมเป้าหมาย จะหยุดรับการเข้าร่วมใหม่`,
    "hunt36": `ขั้นตอนการจับรางวัล`,
    "hunt37": `บันทึกเวลาที่แน่นอนของคำสั่งซื้อสุดท้าย (เช่น 15:47:23)`,
    "hunt38": `รอเวลาบล็อกเชนที่ตรงตามกฎ:`,
    "hunt39": `เวลาบล็อกเชนที่ลงท้ายด้วย 05, 10, 15, 25, 30, 35, 40, 45, 50, 55 หรือเต็มชั่วโมง (เช่น 15:50:00)`,
    "hunt40": `รับแฮชของบล็อกที่ตรงตามเงื่อนไข`,
    "hunt41": `ขั้นตอนการชนะ`,
    "hunt42": `ดึงตัวเลขล้วนจากแฮชของบล็อก`,
    "hunt43": `ตัวอย่างแฮชของบล็อก: 0000000000000000000a16b6f44536e521000000adbcf3f4b2ec018ffabcd123`,
    "hunt44": `ตัวเลขล้วนที่ดึงออกมา: 16644536521000000342018123`,
    "hunt45": `โมดูลัสด้วยจำนวนผู้เข้าร่วมทั้งหมด: `,
    "hunt46": `หมายเลขที่ชนะ`,
    "hunt47": `= (ตัวเลขที่ดึงออกมา % จำนวนผู้เข้าร่วม) + 1 `,
    "hunt48": `หากตัวเลขที่ดึงออกมาคือ 16644536521000000342018123 และจำนวนผู้เข้าร่วมคือ 1,000: `,
    "hunt49": `= (16644536521000000342018123 % 1,000) + 1 = 123 + 1 = 124`,
    "hunt50": `การประกาศผล`,
    "hunt51": `แพลตฟอร์มประกาศหมายเลขที่ชนะและข้อมูลผู้ใช้งานที่เกี่ยวข้อง`,
    "hunt52": `ให้ข้อมูลกระบวนการคำนวณอย่างครบถ้วน (เวลาสั่งซื้อ, แฮชของบล็อกที่ใช้, ตัวเลขที่ดึงออกมา และสูตรคำนวณหมายเลขที่ชนะ)`,
    "hunt53": `ข้อดี`,
    "hunt54": `1. ความยุติธรรม`,
    "hunt55": `ใช้แฮชบล็อกเชนที่เป็นสาธารณะเพื่อให้แน่ใจว่าผลลัพธ์ของการจับรางวัลไม่สามารถคาดเดาหรือเปลี่ยนแปลงได้`,
    "hunt56": `2. ความโปร่งใส`,
    "hunt57": `ผู้ใช้สามารถตรวจสอบค่าของแฮชและกระบวนการจัดสรรหมายเลขได้`,
    "hunt58": `3. ประสิทธิภาพสูง`,
    "hunt59": `ผลลัพธ์สามารถกำหนดได้อย่างรวดเร็วโดยรอให้บล็อกที่เหมาะสมถูกสร้าง`,
    "hunt60": `รายละเอียดประกาศ`,
    "hunt61": `จำนวนที่ซื้อ: `,
    "hunt62": `ชิ้น`,
    "hunt63": `คลิกเพื่อดูรหัสการซื้อ`,
    "hunt64": `รหัสการซื้อ: `,
    "hunt65": `คำอธิบายกฎ`,
    "hunt66": `เกี่ยวกับคำสั่งซื้อ`,
    "hunt67": `เพื่อให้คุณได้รับสินค้าโดยเร็วที่สุด คำสั่งซื้อที่ทำก่อนเวลา 16:00 จะถูกจัดส่งในวันเดียวกันผ่าน XX Courier หรือ XX Courier หากต้องการเร่งด่วนโปรดติดต่อฝ่ายบริการลูกค้าเพื่อชำระค่าบริการเพิ่มเติม`,
    "hunt68": `เกี่ยวกับใบแจ้งหนี้`,
    "hunt69": `สินค้าทั้งหมดที่ขายสามารถออกใบแจ้งหนี้อิเล็กทรอนิกส์ได้ คุณสามารถติดต่อฝ่ายบริการลูกค้าผ่านคำสั่งซื้อของคุณและให้ข้อมูลสำหรับการออกใบแจ้งหนี้ โดยปกติจะใช้เวลา 1-3 วันในการออก หากตรงกับวันหยุด การออกจะเลื่อนออกไป`,
    "hunt70": `ช้อปโชคดี`,


    "new1": "ตัวอย่าง",
    "new2": "สินค้าต้องการผู้เข้าร่วม 1000 คน เวลาการสั่งซื้อสุดท้ายคือ 15:47:23\nเวลาบล็อกล่าสุดที่ตรงกับเวลาจับรางวัลคือ 15:50:00",
    "new3": "ค่าแฮชของบล็อกคือ:",
    "new4": "ดึงเฉพาะตัวเลขจากค่าแฮช:",
    "new5": "คำนวณหมายเลขที่ถูกรางวัล:",
    "new6": "หมายเลขที่ถูกรางวัล",
    "new7": "หมายเลขที่ถูกรางวัลคือ 124 ผู้ใช้ที่ตรงกับหมายเลขนี้คือผู้ชนะ",
    "new8": `แลกเปลี่ยนแล้ว`,
    "new9": `ยังไม่แลกเปลี่ยน`,
    "new10": `น่าเสียดาย คุณไม่ได้รับรางวัล`,
    "new11": `ยินดีด้วย`,
    "new12": `ได้รับสินค้าจากรอบนี้`,
    "new13": `แลกเปลี่ยน`,
    "new14": `โชคดีช้อปปิ้ง`,
    "new15": `สินค้าถูกเก็บเรียบร้อยแล้ว`,

    "new16": "คุณแน่ใจหรือไม่ว่าต้องการรับสินค้า?",
    "new17": "คุณแน่ใจหรือไม่ว่าต้องการแลกเปลี่ยน?",
    "copyS": "คัดลอกสำเร็จ",
    "copyE": "คัดลอกไม่สำเร็จ",
    "new18": "แสดงสินค้า",
    "new19": "หน้าก่อน",
    "new20": "หน้าถัดไป",
    "new21": "ถึง",
    "new22": "หน้า",
    "new23": "ยืนยัน",
    "new24": "กำลังรอการจับสลาก",

    "tool1": "หน้าแรก",
    "tool2": "สินค้า",
    "tool3": "ประกาศ",
    "tool4": "บันทึกการล่าสมบัติ",
    "tool5": "การจัดส่ง",
    "tool6": "กฎเกณฑ์",
    "tool7": "แลกเปลี่ยน",
    "tool8": "ติดต่อเรา",
    "new25": "แลกสินค้า",
    "new26": "กรุณากรอกชื่อผู้ใช้ gobuy ของคุณ",



    "ship1": "ขอบเขตของการใช้งาน",
    "ship2": "กฎการจัดส่งเหล่านี้มีผลบังคับใช้กับทุกคำสั่งซื้อบนแพลตฟอร์มอีคอมเมิร์ซ luckybuy เนื่องจากแพลตฟอร์มรับเฉพาะการชำระด้วย USDT จึงไม่รองรับบัตรเครดิต การชำระด้วยเงินสด หรือการหักค่าขนส่ง ดังนั้นจึงกำหนดกฎต่อไปนี้ไว้",
    "ship3": "1. กฎการจัดส่งภายในสหรัฐอเมริกา",
    "ship4": "วิธีการชำระเงิน",
    "ship5": "รับเฉพาะการชำระเงินด้วย USDT เท่านั้น ไม่รองรับบัตรเครดิตและการชำระด้วยเงินสด",
    "ship6": "บริการเก็บเงินปลายทาง (COD)",
    "ship7": "บริการเก็บเงินปลายทาง (COD) มีให้บริการเฉพาะลูกค้าที่อยู่ในสหรัฐอเมริกาเท่านั้น โดยไม่จำเป็นต้องชำระค่าขนส่งล่วงหน้า",
    "ship8": "นโยบายการจัดส่ง",
    "ship9": "จำนวนเงินสั่งซื้อไม่รวมค่าขนส่ง ซึ่งต้องชำระเพิ่มเติม",
    "ship10": "ขอบเขตการจัดส่ง",
    "ship11": "รองรับการจัดส่งทั่วทั้งแผ่นดินใหญ่ของสหรัฐอเมริกา",
    "ship12": "แจ้งให้ลูกค้าทราบ",
    "ship13": "หลังจากสั่งซื้อแล้ว ลูกค้าต้องตรวจสอบให้แน่ใจว่าข้อมูลติดต่อถูกต้อง สินค้าจะต้องมีการเซ็นรับโดยลูกค้าหรือผู้ที่ได้รับมอบหมายเมื่อรับสินค้า",
    "ship14": "2. กฎการจัดส่งนอกสหรัฐอเมริกา",
    "ship15": "รับเฉพาะการชำระเงินด้วย USDT เท่านั้น ไม่รองรับบัตรเครดิตและการชำระด้วยเงินสด",
    "ship16": "ลูกค้าที่อยู่นอกสหรัฐอเมริกาต้องชำระเงินเพิ่มสำหรับค่าขนส่ง หลังจากได้ชำระค่าสินค้าเสร็จสมบูรณ์แล้ว",
    "ship17": "เมื่อชำระค่าขนส่งเพิ่มเติมเรียบร้อยแล้ว แพลตฟอร์มจะดำเนินการจัดส่งสินค้า",
    "ship18": "นโยบายการเก็บเงินปลายทาง",
    "ship19": "ไม่มีบริการเก็บเงินปลายทางสำหรับลูกค้าที่อยู่นอกสหรัฐอเมริกา ลูกค้าต้องชำระค่าขนส่งทั้งหมดก่อนที่คำสั่งซื้อจะได้รับการดำเนินการ",
    "ship20": "ขั้นตอนการชำระค่าขนส่งเพิ่มเติม",
    "ship21": "หลังจากสั่งซื้อ แพลตฟอร์มจะคำนวณค่าขนส่งตามที่อยู่ของลูกค้า และแจ้งให้ชำระเงินเพิ่มเติมผ่าน USDT",
    "ship22": "เมื่อชำระค่าขนส่งเสร็จสิ้น แพลตฟอร์มจะดำเนินการจัดส่งและให้ข้อมูลการติดตามโลจิสติกส์",
    "ship23": "รองรับการจัดส่งไปยังทุกประเทศทั่วโลก ระยะเวลาการจัดส่งขึ้นอยู่กับเงื่อนไขด้านโลจิสติกส์ในพื้นที่",
    "ship24": "ลูกค้าต้องตรวจสอบให้แน่ใจว่าที่อยู่และข้อมูลติดต่อถูกต้อง ความล้มเหลวในการจัดส่งเนื่องจากข้อมูลไม่ถูกต้องจะเป็นความรับผิดชอบของลูกค้าเอง",
    "ship25": "แพลตฟอร์มไม่รับผิดชอบต่อนโยบายศุลกากรในประเทศปลายทาง ลูกค้าต้องศึกษาขั้นตอนศุลกากรและค่าใช้จ่ายเพิ่มเติมด้วยตนเอง",
    "ship26": "หมายเหตุ",
    "ship27": "1. เมื่อชำระค่าสั่งซื้อสำเร็จแล้ว จะไม่สามารถยกเลิกหรือขอคืนเงินได้ กรุณาตรวจสอบข้อมูลคำสั่งซื้ออย่างรอบคอบก่อนชำระเงิน",
    "ship28": "2. luckybuy จะไม่รับผิดชอบต่อปัญหาที่เกิดขึ้นเนื่องจากเหตุสุดวิสัยระหว่างการขนส่ง (เช่น ภัยพิบัติทางธรรมชาติหรือการเปลี่ยนแปลงนโยบาย) แต่จะพยายามอย่างเต็มที่เพื่อช่วยเหลือลูกค้าในการแก้ไขปัญหา",
    "ship29": "3. หากมีคำถามหรือต้องการความช่วยเหลือใด ๆ กรุณาติดต่อฝ่ายบริการลูกค้าของเรา",
    "ship30": "ขอขอบคุณสำหรับความเข้าใจและการสนับสนุน!",
    "ship31": "luckybuy มุ่งมั่นที่จะให้บริการคุณอย่างดีที่สุด",

    // 礼品卡相关
    'Original Price':'ราคาต้นฉบับ',
    'Actual Payment':'การชำระเงินจริง',
    'Balance':'ยอดคงเหลือ',
    'MessageBox.buy.card': 'คุณแน่ใจหรือไม่ว่าต้องการซื้อบัตรของขวัญนี้?',
    'MyCard':'บัตรของฉัน',
    'Please upload pictures':'โปรดอัปโหลดรูปภาพ',
    'Share audit list':'แชร์รายการตรวจสอบ',
    'Share page':'แชร์หน้า',
    'Audit result':'ผลการตรวจสอบ',
    'Share to the community':'แชร์ไปยังชุมชน',
    'imshares1':'การแนะนำขั้นตอน',
    'imshares2':'ขั้นตอนที่ 1: แชร์ผลิตภัณฑ์บนโซเชียลมีเดีย',
    'imshares3':'ขั้นตอนที่ 2: ถ่ายภาพหน้าจอของหน้าผลิตภัณฑ์ที่แชร์แล้วอัปโหลดไปที่ GoBuy',
    'Share Time':'เวลาแชร์',
    'Audit status':'สถานะการตรวจสอบ',
    'Reason for failure':'เหตุผลที่ล้มเหลว',
    'Pending approval':'รอการอนุมัติ',
    'Approved':'อนุมัติแล้ว',
    'Audit failed':'การตรวจสอบล้มเหลว',
    'Url Copied': 'คัดลอกลิงก์สำเร็จ กำลังเปลี่ยนเส้นทางไปยังการแชร์...',
    "Points Logs": "บันทึกคะแนน",
    "My Points": "คะแนนของฉัน",
    "Go Excharge": "ไปแลก",
    "Confirm points excharge": "คุณแน่ใจหรือไม่ว่าต้องการแปลงคะแนนทั้งหมดเป็นยอดคงเหลือ?",
    'is not share': 'คุณยังไม่ได้ทำภารกิจการแบ่งปันให้เสร็จสมบูรณ์',
    'is buied': 'คุณได้ซื้อของวันนี้แล้ว',
    'My card': 'บัตรของฉัน',
    "Country/Region": "ประเทศ/ภูมิภาค",
    "Contact info": "ข้อมูลติดต่อ",
    "Please enter real name": "กรุณาใส่ชื่อจริง",
    "Please enter Phone Number": "กรุณาใส่หมายเลขโทรศัพท์",
    "Please enter State/Province/Region": "กรุณาใส่รัฐ/จังหวัด/ภูมิภาค",
    "Please enter City": "กรุณาใส่เมือง",
    "Please enter Street Address": "กรุณาใส่ที่อยู่ถนน",
    "Please enter Postal Code": "กรุณาใส่รหัสไปรษณีย์",
    "lucky_draw_winning_products": "สินค้าจากการจับฉลาก",
    "refundAdd": "ขอคืนเงิน",
    "refundDescription": "คำอธิบายการคืนเงิน",
    "productQualityIssue": "ปัญหาคุณภาพสินค้า",
    "logisticsTransportIssue": "ปัญหาการขนส่งและโลจิสติกส์",
    "sellerPlatformIssue": "ปัญหาผู้ขายหรือแพลตฟอร์ม",
    "personalReason": "เหตุผลส่วนตัว",
    "otherSpecialCases": "กรณีพิเศษอื่นๆ",
    "hunt points rule": "คำอธิบายคะแนน",
    "hunt points rule1": "1. การได้รับคะแนน: ผู้ใช้ที่เข้าร่วมการซื้อโชคดีสามารถได้รับ 1 คะแนนสำหรับทุก ๆ 0.1 ดอลลาร์สหรัฐที่ลงทุน",
    "hunt points rule2": "2. การแลกคะแนน: 1 คะแนน = 0.01% ดอลลาร์สหรัฐ",
    'Login Password': "รหัสผ่านสำหรับเข้าสู่ระบบ",
    "Level": "ระดับ",
    
    "guide.Rewards": "แนะนำรางวัล",
    "guide.title": "คู่มือสำหรับผู้เริ่มต้น",
    "guide.Invitation.Reward": "รางวัลกิจกรรม",
    "guide.Order.Sharing": "แชร์รีวิวการสั่งซื้อ",
    "guide.section1.title": "คู่มือการซื้อ Lucky Buy",
    "guide.section1.step1": "เลือกซื้อ: เข้าสู่โซนดอลลาร์ เลือกสินค้าที่ชอบ",
    "guide.section1.step2": "เลือกจำนวน: กรอกจำนวนส่วนที่ต้องการเข้าร่วมซื้อ",
    "guide.section1.step3": "จำนวนที่ซื้อ: ซื้อเพียง 1 รายการ ใช้แค่ $0.1",
    "guide.section1.step4": "รอการจับรางวัล: ระบบจะสุ่มหาผู้โชคดีโดยอัตโนมัติ",
    "guide.section2.title": "คู่มือการซื้อกล่องสุ่ม",
    "guide.section2.step1": "เปิดกล่องสุ่ม: คลิกเข้าโซนกล่องสุ่ม",
    "guide.section2.step2": "เข้าร่วมทันที: ชำระเงิน 10 ดอลลาร์",
    "guide.section2.step3": "ประกาศรางวัล: ชนะรางวัลมูลค่าสูงสุดถึง 3 ล้านดอลลาร์",
    "guide.section3.title": "คู่มือการซื้อบัตรของขวัญ",
    "guide.section3.step1": "แชร์ในชุมชน: แชร์กิจกรรมทันทีและอัปโหลดข้อมูล",
    "guide.section3.step2": "เลือกมูลค่า: เลือกราคาบัตรของขวัญได้ตามต้องการ",
    "guide.section3.step3": "ซื้อบัตรของขวัญ 100 ใบในราคาเพียง $98",
    "guide.section3.step4": "รับซื้อทันที: รับซื้อ 100% รับเงิน $2",
    "guide.tip.title": "คำแนะนำที่เป็นมิตร: สิทธิประโยชน์สุดคุ้มที่ไม่ควรพลาด",
    "guide.tip.luckyBuy": "ใช้เงินเพียง 0.1 ดอลลาร์ เข้าร่วม มีโอกาสชนะรางวัลตั้งแต่ 1 ถึง 50,000 ดอลลาร์!",
    "guide.tip.luckyBuy1": "รางวัลคอมมิชชั่นทีม: เชิญเพื่อนซื้อ รับคอมมิชชั่นสูงสุด 0.2%!",
    "guide.tip.luckyBuy2": "แลกคะแนน: ทุกการซื้อ 1 ส่วนของ Lucky Buy สะสม 1 คะแนน, 1000 คะแนน = 0.1 ดอลลาร์!",
    "guide.tip.example": "ตัวอย่าง:",
    "guide.tip.example1": "คุณเชิญผู้ใช้ A, A ซื้อ 1000 ดอลลาร์ → คุณได้รับคอมมิชชั่น 2 ดอลลาร์",
    "guide.tip.example11": "A เชิญผู้ใช้ B, B ซื้อ 1000 ดอลลาร์ → คุณได้รับคอมมิชชั่นเพิ่มอีก 1 ดอลลาร์",
    "guide.tip.boxTitle": "การจับรางวัลกล่องสุ่ม",
    "guide.tip.box": "ใช้เงิน 10 ดอลลาร์เข้าร่วมครั้งละ 1 ครั้ง รางวัลมูลค่าสูงถึง 3 ล้านดอลลาร์!",
    "guide.tip.cardTitle": "บัตรของขวัญ",
    "guide.tip.card": "รางวัลคอมมิชชั่นทีม: เชิญเพื่อนซื้อ รับคอมมิชชั่นสูงสุด 0.4%!",
    "guide.tip.example2": "เมื่อคุณเชิญผู้ใช้ A ให้ซื้อบัตรของขวัญมูลค่า 100 ดอลลาร์ คุณจะได้รับค่าคอมมิชชัน 0.4 ดอลลาร์",
    "guide.tip.example3": "หาก A เชิญผู้ใช้ B และ B ซื้อบัตรของขวัญมูลค่า 100 ดอลลาร์ คุณจะได้รับค่าคอมมิชชันเพิ่มอีก 0.2 ดอลลาร์",
    "guide.tip.callToAction": "เข้าร่วมเลย เริ่มต้นการเดินทางโชคดีของคุณ!",
    "guide.warning.title": "คำเตือนที่เป็นมิตร",
    "guide.warning.rule1": "สถานการณ์ใดบ้างที่ทำให้คอมมิชชั่นเป็นโมฆะ?",
    "guide.warning.answer1": "ใช้ซอฟต์แวร์หรือแพลตฟอร์มอื่นเพื่อรับคอมมิชชั่นอย่างไม่ถูกต้อง หากตรวจพบ จะถูกตัดคอมมิชชั่นทั้งหมดและระงับบัญชี",
    "guide.warning.rule2": "เชิญตัวเองจะได้รับคอมมิชชั่นไหม?",
    "guide.warning.answer2": "ไม่ได้ เราจะตรวจสอบด้วยตนเอง หากพบการโกง จะถูกตัดคอมมิชชั่นทั้งหมด ยกเลิกสิทธิ์รับคอมมิชชั่น และลบบัญชีของคุณ",
    "invite.title": "สิทธิประโยชน์มาแล้ว | เชิญเพื่อนและลุ้นรับ 4 รางวัลใหญ่!",
    "invite.reward1.title": "รางวัลที่ 1: เชิญเข้ากลุ่ม ง่าย ๆ รับเงินดอลลาร์ + บัตรของขวัญ",
    "invite.reward1.item1": "เชิญสมาชิกใหม่ 10 คนเข้ากลุ่ม รับรางวัล红包ทันที!",
    "invite.reward1.item2": "พร้อมรับบัตรของขวัญมูลค่า 1 ดอลลาร์",
    "invite.reward1.item3": "เชิญมากยิ่งได้มาก! แจก红包ทันที บัตรของขวัญแลกได้เลย!",
    "invite.reward2.title": "รางวัลที่ 2: Lucky Buy รับคอมมิชชั่นง่าย ๆ",
    "invite.reward2.item1": "เพื่อนเข้าร่วม Lucky Buy คุณจะได้รับคอมมิชชั่น!",
    "invite.reward2.item2": "คอมมิชชั่นไม่จำกัด ซื้อเยอะได้เยอะ!",
    "invite.reward3.title": "รางวัลที่ 3: บัตรของขวัญ",
    "invite.reward3.item1": "เพื่อนซื้อบัตรของขวัญ คุณได้รับคอมมิชชั่นทันที!",
    "invite.reward3.item2": "ลิงก์แชร์ฟรี ติดตามอัตโนมัติ ใช้งานง่ายมาก:",
    "invite.reward3.item3": "ส่งลิงก์ → เพื่อนสั่งซื้อ → รอรับเงิน!",
    "invite.callToAction": "รีบเชิญเพื่อนเข้ากลุ่ม รับสิทธิประโยชน์กลับบ้านไปเต็ม ๆ! เล่นและหาเงินไปพร้อมกัน!",
    "share.title": "แชร์ประสบการณ์ถูกรางวัล GoBuy รับบัตรของขวัญ 1 ดอลลาร์",
    "share.subtitle": "หัวข้อแชร์",
    "share.content1": "ขอบคุณ GoBuy การช็อปปิ้งโชคดี! สมาชิกของเราลงทุนเล็กน้อยและถูกรางวัล ถอนเงินสำเร็จ!✨",
    "share.content2": "ถึงตาคุณแล้ว! แค่แชร์ประสบการณ์ถูกรางวัล รับบัตรของขวัญ GoBuy ฟรี 1 ดอลลาร์! อย่าพลาด—ง่าย ได้รางวัลเยอะ สนุกไม่มีหยุด!",
    "share.inviteLink": "แนบรหัสลิงก์เชิญของคุณ:",
    "share.stepsTitle": "วิธีเข้าร่วม:",
    "share.step1": "อัปโหลดภาพหน้าจอโค้ดซื้อ/ใบสั่งซื้อในโซน Lucky Buy",
    "share.step2": "อัปโหลดภาพหน้าจอข้อความ 'ขอแสดงความยินดี คุณถูกรางวัล!'",
    "share.step3": "อัปโหลดภาพหน้าจอคำขอถอนเงินและการทำธุรกรรมสำเร็จ",
    "share.step4": "หลังทำครบขั้นตอน ส่งภาพแชร์บนโซเชียลมีเดียให้ทีมสนับสนุนตรวจสอบ",
    "share.email": "อีเมลฝ่ายสนับสนุนลูกค้า:",
    "share.footer": "ขอให้โชคดีอยู่กับคุณ—เล่นต่อและชนะต่อไป! GoBuy—ทำให้การช็อปปิ้งทุกวันเต็มไปด้วยความสนุกและรางวัล!",
    "doubleBet.title": "การเดิมพันมหัศจรรย์｜3 ขั้นตอนง่ายๆ กลับมาชนะและคว้ารางวัลใหญ่!",
    "doubleBet.step1": "รอบที่ 1: เลือกโซน $1, ซื้อ $0.5, ซื้อ 5 หน่วยและหยุดเมื่อชนะ",
    "doubleBet.step2": "หากยังไม่ชนะ รอบที่ 2: เลือกโซน $3, ซื้อ $1.5, ซื้อ 15 หน่วยและหยุดเมื่อชนะ",
    "doubleBet.step3": "หากยังไม่ชนะ รอบที่ 3: เลือกโซน $8, ซื้อ $4, ซื้อ 40 หน่วยและยินดีด้วยเมื่อชนะ",
    "doubleBet.step4": "หลังจากชนะ คุณสามารถชดเชยความสูญเสียจากรอบก่อนหน้าและทำกำไรได้ จากนั้นเริ่มใหม่จากรอบที่ 1",
    "invite.reward4.title": "รางวัล 4: สิทธิพิเศษจำกัดเวลา | ของขวัญเฉพาะสำหรับผู้ใช้ใหม่",
    "invite.reward4.step1": "เข้าร่วมการซื้อโชคดี 1 ครั้งฟรี",
    "invite.reward4.step2": "เปิดใช้งานลอตเตอรี่กล่องลึกลับ 1 ครั้งฟรี",
    "invite.reward4.step3": "ทำภารกิจที่ระบุและรับรางวัลเงินสดเพิ่มอีก 1 ดอลลาร์",
    "reward.register.title": "รางวัลการลงทะเบียน",
    "reward.register.point1": "ผู้ใช้ใหม่จะได้รับสิทธิ์ Lucky Buy ฟรี 1 ครั้งเมื่อสมัครสมาชิก",
    "reward.register.point2": "เข้าร่วมกลุ่มหลังลงทะเบียนเพื่อร่วมกิจกรรมรับอั่งเปา",
    "reward.task.title": "รางวัลภารกิจ",
    "reward.task.point1": "เข้าสู่ระบบแบบผู้เยี่ยมชมและเปิดกล่องสุ่ม 1 กล่อง",
    "reward.task.point2": "ทำภารกิจ Lucky Buy 3 โซนนี้ให้ครบ โซนละ 1 ครั้ง:",
    "reward.task.subtask1": "โซน $1: ซื้อ $0.5",
    "reward.task.subtask2": "โซน $3: ซื้อ $1.5",
    "reward.task.subtask3": "โซน $8: ซื้อ $4",
    "reward.task.point3": "ทำทั้ง 2 ภารกิจสำเร็จ รับรางวัลกิจกรรม $1!",
    "reward.share.title": "รางวัลการแชร์",
    "reward.share.desc": "ฉันเพิ่งถูกรางวัลกล่องสุ่มและจับรางวัลสุดโชคดีจาก GoBuy!",
    "reward.share.desc3": "หลังสมัคร ฉันก็ถูกรางวัลทันที — สุดยอดไปเลย!",
    "reward.share.desc4": "✨แชร์ภาพหน้าจอของรางวัลเพื่อรับโบนัส 1 ดอลลาร์",
    "reward.share.desc1": "ชวนเพื่อน 10 คนและรับ $1 เมื่อเพื่อนสมัครเสร็จสิ้น ชวนครบ 1,000 คนรับ $100 ไปเลย ไม่มีขีดจำกัด ยิ่งชวนมาก ยิ่งได้มาก!",
    "reward.invite.title": "รางวัลเชิญชวน",
    "reward.invite.desc": "เชิญเพื่อน 10 คนและให้พวกเขาลงทะเบียนให้เสร็จสมบูรณ์",
    "reward.share.desc2": "ทำภารกิจด้านบนให้เสร็จเพื่อรับรางวัลจากการแชร์และเชิญชวน!",
    "reward.invite.desc1": "ทำภารกิจด้านบนให้เสร็จเพื่อรับรางวัลกิจกรรมเชิญชวน!",
}
export default Thai
